import "core-js/modules/es.array.push.js";
import UserService from '@/services/UserService';
export default {
  data() {
    return {
      searchText: '',
      pagination: {
        numPages: 1,
        page: 1,
        perPage: 25
      },
      channel_id: null,
      loading: false,
      channels: [],
      videos: [],
      display: 0,
      currentVideo: null
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      UserService.getNetworkInfo().then(network => {
        this.channels = network.channels;
        if (this.channels.length === 1) {
          this.$router.push('/video/channel/' + this.channels[0].id);
        }
      }).catch(err => {
        this.$aim.error(err.response);
      }).finally(() => {
        this.loading = false;
      });
    },
    getVideoCount(channel) {
      return Number(channel.publishedvideocount || channel.videocount || 0);
    },
    isLiveChannel(channel) {
      return channel.islive_now === '1';
    },
    getChannelImage(channel) {
      return channel.bannerimage_display || channel.logoimage_display || channel.headerimage_display;
    }
  }
};